import { createFormAction } from 'redux-form-saga';
import * as categoryFormTypes from './categoryFormTypes';
import {createAction} from "redux-actions";
import * as phraseTRFormTypes from "../phraseTRForm/phraseTRFormTypes";

export const submitCategoryForm = createFormAction(categoryFormTypes.SUBMIT_CATEGORY_FORM);
